export default __webpack_public_path__ + "static/media/UserGuide_zh_CN.1fc5fb49.pdf";